import type { BrandedIconProps } from './types';

/**
 * Mastercard — global card network. The mark is two overlapping circles,
 * red and yellow, with their intersection rendered in orange (the
 * "interlocking circles" mark in use since 2016).
 *
 * Official colors per Mastercard Brand Center
 * (https://brand.mastercard.com/brandcenter.html):
 *  - `#EB001B` Mastercard red    (left circle).
 *  - `#F79E1B` Mastercard yellow (right circle).
 *  - `#FF5F00` Mastercard orange (overlap of the two discs).
 *
 * The 2016 mark dropped the wordmark from the symbol — at 24px we keep
 * just the discs (recognisable instantly across LATAM). DO NOT recolor —
 * see `BrandedIconProps` for the full rationale.
 */
export function MasterCardIcon({
  size = 24,
  className,
  'aria-label': ariaLabel = 'Mastercard',
}: BrandedIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      {/* Left red disc */}
      <circle cx="9" cy="12" r="6.5" fill="#EB001B" />
      {/* Right yellow disc */}
      <circle cx="15" cy="12" r="6.5" fill="#F79E1B" />
      {/* Overlap region — Mastercard orange. Drawn as the intersection of
          the two discs by clipping a vertical band between cx=9 and cx=15
          to one of the circles via two arcs joined at the top/bottom of
          the overlap. */}
      <path fill="#FF5F00" d="M12 6.96a6.49 6.49 0 0 1 0 10.08 6.49 6.49 0 0 1 0-10.08Z" />
    </svg>
  );
}
